export default __webpack_public_path__ + "static/media/7.7c7e1da5.png";